import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
import { SlabRate } from 'utils/types';

export interface SlabRatePayload {
  offenceId: number;
  upperBound: number;
  lowerBound: number;
  amount: number;
}

const addSlabRate = async (data: SlabRatePayload) => {
  const response = await axiosInstance.post('/offence/slabRate', data);
  return response.data;
};

const useAddSlabRate = (): UseMutationResult<
  SlabRate,
  Error,
  SlabRatePayload
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addSlabRate,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['slabRates', variables.offenceId],
      });
    },
    onError: (error: Error) => {
      console.error('Error adding slab rate:', error.message);
    },
  });
};

export default useAddSlabRate;
